<app-navbar></app-navbar>

<div class="print-hide">
  <div class="container prepare-panel">
    <header class="prepare-header">
      <h2 class="prepare-title">
        Print racecards<span *ngIf="fixtureCourseLabel"> for {{ fixtureCourseLabel }}</span><span *ngIf="fixtureDateLabel"> on {{ fixtureDateLabel }}</span>
      </h2>
      <p class="prepare-lead">Choose options, prepare the cards, then print when ready.</p>
    </header>

    <!-- Step 1: options -->
    <section class="prepare-step" [class.is-disabled]="meta.loading">
      <div class="prepare-step-label">1. Include comments?</div>
      <div
        [(ngModel)]="withRPC"
        class="btn-group btn-group-toggle prepare-rpc-toggle"
        [disabled]="meta.started || meta.loading"
        ngbRadioGroup
        name="radioCommentsVisible"
      >
        <label ngbButtonLabel class="btn btn-outline-primary">
          <input ngbButton type="radio" [value]="false"> Without RPC
        </label>
        <label ngbButtonLabel class="btn btn-outline-primary">
          <input ngbButton type="radio" [value]="true"> With RPC
        </label>
      </div>
      <p class="prepare-hint" *ngIf="!withRPC">
        Faster prepare — runners only, no previous comments or enquiries.
      </p>
      <p class="prepare-hint" *ngIf="withRPC">
        Slower prepare — loads the latest RPC comment and enquiry for each runner. Can take a few minutes on large fixtures.
      </p>
    </section>

    <!-- Step 2: prepare -->
    <section class="prepare-step">
      <div class="prepare-step-label">2. Prepare</div>
      <button
        type="button"
        class="btn btn-primary prepare-btn"
        [disabled]="meta.started || meta.loading"
        (click)="start()"
      >
        <span *ngIf="!meta.loading && !prepareReady">Prepare racecards</span>
        <span *ngIf="meta.loading">
          <fa name="circle-o-notch" animation="spin"></fa>
          Preparing…
        </span>
        <span *ngIf="!meta.loading && prepareReady">Prepare again</span>
      </button>
    </section>

    <!-- Progress (log only while preparing) -->
    <section class="prepare-log-panel" *ngIf="prepareLog.length">
      <div class="prepare-log-header">
        <span>Progress</span>
        <span class="prepare-elapsed" *ngIf="meta.loading || prepareReady">
          {{ prepareProgress }}% · Elapsed {{ elapsedLabel }}
        </span>
      </div>
      <div class="prepare-progress">
        <div
          class="progress"
          role="progressbar"
          [attr.aria-valuenow]="prepareProgress"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div
            class="progress-bar"
            [class.progress-bar-striped]="meta.loading"
            [class.progress-bar-animated]="meta.loading"
            [class.bg-success]="prepareReady && !meta.loading"
            [style.width.%]="prepareProgress"
          ></div>
        </div>
      </div>
      <ng-container *ngIf="meta.loading">
        <ul class="prepare-log">
          <li *ngFor="let line of prepareLogTail; let last = last" [class.is-current]="last">
            {{ line }}
          </li>
        </ul>
        <div class="prepare-estimate" *ngIf="withRPC">
          With RPC, each runner needs extra API calls — please keep this tab open.
        </div>
      </ng-container>
    </section>

    <!-- Step 3: print (only when ready) -->
    <section class="prepare-step prepare-print-step" *ngIf="prepareReady && !meta.loading">
      <div class="prepare-step-label">3. Print</div>
      <p class="prepare-ready-msg">
        Racecards ready{{ withRPC ? ' (with RPC)' : ' (without RPC)' }}
        <span *ngIf="races.length"> — {{ races.length }} race<span *ngIf="races.length !== 1">s</span></span>.
      </p>
      <button
        type="button"
        class="btn btn-primary btn-lg prepare-print-btn"
        [disabled]="!layoutReady"
        (click)="doPrint()"
      >
        <span *ngIf="layoutReady">Print racecards</span>
        <span *ngIf="!layoutReady">
          <fa name="circle-o-notch" animation="spin"></fa>
          Fitting page layout…
        </span>
      </button>
    </section>

    <div class="prepare-footer">
      <a class="btn btn-link prepare-back" [routerLink]="['/races', fixture.fixtureYear, fixture.fixtureId]">
        ← Back to the fixture
      </a>
    </div>
  </div>
</div>
<div *ngIf="!meta.loading" class="print-visible">
  <div
    class="container-fluid race-sheet"
    *ngFor="let race of races; index as racei; last as last"
    [attr.data-race-index]="racei"
    [class.page-break-after]="!last"
  >
    <div class="race-header-measure">
      <!-- RACE BASIC -->
      <div class="row px-0 mx-0">
        <div class="col-10 px-0 mx-0">
          <h5>{{races[racei].raceDateTime | date:'h:mm'}} {{races[racei].name}}</h5>
          <strong>Going: </strong>
          <span>{{fixture.goingText || 'Unknown'}}</span>
        </div>
        <div class="col text-right">
          {{race.info.tvCoverage}}<br>{{race.info.distance}}
        </div>
      </div>
      <!-- RACE INFO -->
      <div class="row">
        <div class="col-2">
          <strong>For: </strong>
          <span> {{race.info.ageLimit}}</span>
          <span *ngIf="race.info.ratingBandLowest !== -1"> {{race.info.ratingBandLowest}} - {{race.info.ratingBandHighest}}</span>
        </div>
        <div class="col-2">
          <strong>Value: </strong> {{race.info.totalPrize | currency:'GBP'}}
        </div>
        <div class="col-8">
          <strong>Prizes: </strong>
          <span *ngFor="let prize of race.info.prizes; index as index; first as first">
            <span *ngIf="prize !== '0.00'" class="no-wrap">
              <span *ngIf="!first"> | </span>
              <span>{{index+1}}. {{prize | currency:'GBP'}}</span>
            </span>
          </span>
        </div>
      </div>
      <hr>
    </div>
    <!-- ENTRIES -->
    <div class="race-entries">
    <div
      class="entry-block entry-block-dense no-page-break border-b"
      *ngFor="let entry of race.entries; index as entryi"
      [attr.data-entry-index]="entryi"
      [ngClass]="{
        'non-runner': entry.nonRunnerDeclaredDate,
        'entry-page-break': entry.forcePageBreak
      }"
      [style.font-size.em]="entry.customFontSize"
      [style.min-height.px]="entry.stretchMinHeightPx"
      [style.height.px]="withRPC ? entry.stretchMinHeightPx : null"
      [style.max-height.px]="withRPC ? entry.stretchMinHeightPx : null"
    >
      <div class="entry-content">
      <div
        class="row flex-nowrap entry-row"
        [ngClass]="{
          'entry-row-packed': (!withRPC && entry.customHeightPx != null) || (withRPC && entry.stretchMinHeightPx != null)
        }"
        [style.min-height.px]="withRPC ? null : entry.minHeightPx"
        [style.height.px]="withRPC ? null : entry.customHeightPx"
        [style.max-height.px]="withRPC ? null : entry.customHeightPx"
      >
        <div class="entry-num-col d-flex flex-column justify-content-center align-items-center px-0 mx-0">
          <span class="d-flex align-self-center lead">{{entry.saddleClothNumber}}</span>
          <span class="d-flex align-self-center" *ngIf="entry.stall">[{{entry.stall}}]</span>
        </div>
        <div
          class="entry-silk-col d-flex align-items-center justify-content-center"
          [style.width.px]="(entry.imageSize || 40) + 16"
          [style.min-width.px]="(entry.imageSize || 40) + 16"
        >
          <img
            [style.height.px]="entry.imageSize"
            [style.width.px]="entry.imageSize"
            class="img-silk"
            src="https://draper.horseracing.software/silks?id={{entry.colourCode}}&desc={{entry.colourDescription}}{{entry.nonRunnerDeclaredDate ? '&nonrunner' : ''}}"
          >
        </div>
        <div class="col-1 d-flex flex-column flex-grow justify-content-center pr-0 mx-0">
          <div>{{entry.formFigures.trim()}}</div>
          <div *ngIf="entry.previousForm.data.length">
            <span>{{entry.previousForm.data[0].performanceFigure}}</span>
            <!-- <span *ngIf="entry.previousForm.data[1]"> ({{entry.previousForm.data[1].performanceFigure}})</span> -->
            <span *ngIf="entry.rating"> ({{entry.rating}})</span>
          </div>
          <div *ngIf="entry.headGears" [class.pt-2]="withRPC" [class.pt-1]="!withRPC">
            <span *ngIf="entry.headGears">
              <span *ngFor="let item of entry.headGears">
                <span>{{item.code}}<sup *ngIf="item.firstTimeIndicator">1</sup></span>
              </span>
            </span>
          </div>
        </div>
        <div class="col-5 d-flex flex-column flex-grow justify-content-center px-0 mx-0">
          <span
            class="d-flex align-items-center justify-content-start text-nowrap"
            [class.pb-2]="withRPC"
            [class.pb-1]="!withRPC"
          >
            <strong>{{entry.horseName | uppercase}}</strong>
            <span class="entry-flags">
              <em *ngIf="entry.nonRunnerDeclaredDate" class="px-1">
                <ng-container *ngIf="!entry.nonRunnerDeclaredReason">Non Runner</ng-container>
                <ng-container *ngIf="entry.nonRunnerDeclaredReason">NR - {{entry.nonRunnerDeclaredReason}}</ng-container>
              </em>
              <em *ngIf="entry.indicators.isWithdrawn" class="px-1">Withdrawn</em>
              <em *ngIf="entry.indicators.hasBeenSelectedForSampling" class="px-1">Selected for Sampling</em>
              <em *ngIf="entry.indicators.hasJockeyChange" class="px-1">
                Jockey Change<span *ngIf="entry.jockeyChangeHistory.length > 1"> ({{entry.jockeyChangeHistory.length}})</span>
              </em>
              <em *ngIf="entry.indicators.isAPeprHorse" class="px-1">PEPR</em>
              <em *ngIf="entry.indicators.hadWindSurgerySinceLastRun" class="px-1">Wind Surgery</em>
              <em *ngIf="entry.indicators.hasNewTrainer" class="px-1">New Trainer</em>
            </span>
          </span>
          <div class="d-flex flex-wrap align-items-baseline">
            <span>{{entry.horseAge}}YO/{{entry.horseColour ? entry.horseColour.substring(0, 1) : ''}}/{{entry.horseSex ? entry.horseSex.substring(0, 1) : ''}}</span>
            <span class="px-1">-</span>
            <span *ngIf="entry.lastSampledDate">Sampled {{entry.lastSampledDate | date:'dd/MM/yy'}}</span>
            <span *ngIf="!entry.lastSampledDate">Never Sampled</span>
          </div>
          <div
            class="d-flex flex-wrap align-items-baseline"
            [class.pt-1]="withRPC"
            *ngIf="entry.daysSinceLastRan.length || entry.weightCarriedValue"
          >
            <ng-container *ngIf="entry.daysSinceLastRan.length">
              <span class="pr-1">{{entry.daysSinceLastRan[0].days}} days</span>
              <span>({{entry.daysSinceLastRan[0].raceType}})</span>
            </ng-container>
            <span class="px-1" *ngIf="entry.daysSinceLastRan.length && entry.weightCarriedValue">·</span>
            <span *ngIf="entry.weightCarriedValue">{{entry.weightCarriedValue | toStones}}</span>
          </div>
          <small *ngIf="entry.shortDispensation" class="text-nowrap d-inline-block">{{entry.shortDispensation}}</small>
        </div>
        <div class="col-2 d-flex flex-column flex-grow justify-content-center px-0 mx-0">
          <span class="d-inline-block text-truncate">{{entry.jockeyKnownAs}}<span *ngIf="entry.jockeyClaim">({{entry.jockeyClaim}})</span></span>
          <span class="d-inline-block text-truncate">{{entry.trainerKnownAs}}</span>
          <span class="d-inline-block text-truncate">{{entry.ownerKnownAs}}</span>
        </div>
      </div>
      <div
        class="entry-notes"
        *ngIf="entry.latest && (entry.latest.enquiry.date || entry.latest.comment.date)"
      >
        <div *ngIf="entry.latest.enquiry.date">
          <strong>{{entry.latest.enquiry.date | date:'dd/MM/yy h:mm'}} {{entry.latest.enquiry.courseShortName}}</strong>
          <span> {{entry.latest.enquiry.offence.offence}}</span>
          <span *ngIf="entry.latest.enquiry.offence.subOffence"> {{entry.latest.enquiry.offence.subOffence}}</span>
        </div>
        <div *ngIf="entry.latest.comment.date">
          <strong>{{entry.latest.comment.date | date:'dd/MM/yy h:mm'}} {{entry.latest.comment.courseShortName}}</strong>
          <span *ngFor="let rpc of entry.latest.comment.rpc; last as last">
            <span> {{rpc.racePerformanceComment}}</span>
            <span *ngIf="!last">, </span>
          </span>
        </div>
      </div>
      </div><!-- /.entry-content -->
    </div>
    </div><!-- /.race-entries -->
  </div>
</div>
